<div class="password-requirements text-color">
  <p class="title">
    {{ "PAGE.AUTH.PASSWORD_REQUIREMENTS.PASSWORD_REQUIREMENTS" | translate }}
  </p>
  <ul>
    <li>
      {{ "PAGE.AUTH.PASSWORD_REQUIREMENTS.CHARACTERS_NUMBER" | translate }}
    </li>
    <li>
      {{ "PAGE.AUTH.PASSWORD_REQUIREMENTS.UPP_AND_LOW_CHARACTER" | translate }}
    </li>
    <li>{{ "PAGE.AUTH.PASSWORD_REQUIREMENTS.MIX_CHARACTER" | translate }}</li>
    <li>
      {{ "PAGE.AUTH.PASSWORD_REQUIREMENTS.SPECIAL_CHARACTER" | translate }}
    </li>
    <li *ngIf="showOldPasswordRule">
      {{ "PAGE.AUTH.PASSWORD_REQUIREMENTS.SAME_PASSWORD" | translate }}
    </li>
  </ul>
</div>
